import React from "react";
import type {FC, ReactNode} from "react";
import {View, Box, Inline, InlineItem} from "@unibuddy/patron";

const AuthPage: FC<{title: ReactNode; headerLeftButton?: ReactNode; children: ReactNode}> = ({
    children,
    title,
    headerLeftButton,
}) => {
    return (
        <View flex="1" maxH="100%" overflow="auto">
            <Box minW="100%" paddingY="xxsmall" flexShrink={0}>
                <Inline space="medium" verticalAlign="center" wrap="nowrap">
                    <InlineItem flexShrink={0}>{headerLeftButton}</InlineItem>
                    {title}
                </Inline>
            </Box>
            {children}
        </View>
    );
};

export default AuthPage;
